import { render, staticRenderFns } from "./RadioVideo.vue?vue&type=template&id=5355f9b6&"
import script from "./RadioVideo.vue?vue&type=script&lang=js&"
export * from "./RadioVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsArrowRight: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/ArrowRight.vue').default,DownloadLinks: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/base/DownloadLinks.vue').default,IconsCloseForm: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/CloseForm.vue').default,IconsPaperPlane: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/PaperPlane.vue').default,DynamicForm: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/base/DynamicForm.vue').default})
